import { useMemo } from 'react';
import { FiSave } from 'react-icons/fi';
import { CgSoftwareDownload, CgSoftwareUpload } from 'react-icons/cg';
import type { ItemType } from 'antd/es/menu/interface';
import { ActionsDropdown } from '@app/components/actions-dropdown/ActionsDropdown';

type FlowActionsDropdownProps = {
    showExport: boolean;
    handleBtnClick: (action: 'Save' | 'Export' | 'Import' | 'Clear') => void;
    isSaveDisabled: boolean;
    isClearDisabled: boolean;
    isImportExportDisabled: boolean;
};

const FlowActionsDropdown = ({
    showExport,
    handleBtnClick,
    isSaveDisabled,
    isClearDisabled,
    isImportExportDisabled,
}: FlowActionsDropdownProps) => {
    const items = useMemo(() => {
        return [
            {
                key: '1',
                label: showExport ? 'Export' : 'Import',
                icon: showExport ? (
                    <CgSoftwareDownload size={20} />
                ) : (
                    <CgSoftwareUpload size={20} />
                ),
                onClick: () => handleBtnClick(showExport ? 'Export' : 'Import'),
                disabled: isImportExportDisabled,
            },
            {
                key: '2',
                label: 'Save',
                icon: <FiSave size={20} />,
                onClick: () => handleBtnClick('Save'),
                disabled: isSaveDisabled,
            },
            { type: 'divider' } as ItemType,
            {
                icon: <div />,
                key: '3',
                label: 'Clear',
                onClick: () => handleBtnClick('Clear'),
                disabled: isClearDisabled,
            },
        ];
    }, [showExport, handleBtnClick, isSaveDisabled, isClearDisabled, isImportExportDisabled]);

    return (
        <div className="flow-actions-dropdown">
            <ActionsDropdown title="Actions" items={items} />
        </div>
    );
};

export default FlowActionsDropdown;
